import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Modal } from '@web/components';
import { Radio, ButtonLink } from '@web/atoms';
import { Footer } from '../Footer';
import { Question } from '../Question';
import { FormFieldsContainer } from '../FormFieldsContainer';
import { useSessionCustomer } from '../../customer';
import { useReporter } from '../../reporter';
import { onboardingSubmitted } from '../events';
import { ApiResult } from '../../api';
import {
  StyledForm,
  CtaText,
  ModalContainer,
  ModalHeading,
  ModalContent,
  ModalContentTitle,
  ModalContentBody,
} from './styles';
import { schema } from './schema';

export const PoopForm = ({
  poopQuestionPrompt,
  subheadline,
  ctaText,
  goBack,
  onSubmit,
  responses,
  index,
  defaultValues,
  modal,
  ctaButtonText,
}) => {
  const [shown, setShown] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { isSubmitting, isSubmitted },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  const reporter = useReporter();
  const { customer } = useSessionCustomer();

  const submitForm = async data => {
    reporter.tag(onboardingSubmitted(index, 'poop_type', customer));
    const result = await onSubmit(data);

    ApiResult.ifError(result, () =>
      setTimeout(() =>
        reset(getValues(), {
          keepIsSubmitted: false,
        }),
      ),
    );
  };

  return (
    <StyledForm onSubmit={handleSubmit(submitForm)}>
      <FormFieldsContainer $maxWidth={350}>
        <Question prompt={poopQuestionPrompt} subheadline={subheadline}>
          <Controller
            control={control}
            name="stoolType"
            render={({ field: { ref, ...field } }) => (
              <>
                <Radio
                  {...field}
                  choices={responses}
                  direction="column"
                  name="stoolType"
                  legendText="stool type"
                  onClick={() => setValue('stoolType', null)}
                />
              </>
            )}
          />
        </Question>
        <ButtonLink onClick={() => setShown(true)}>
          <CtaText>{ctaText}</CtaText>
        </ButtonLink>
      </FormFieldsContainer>
      <Footer
        mobileCTAText={ctaButtonText?.mobileCTA}
        desktopCTAText={ctaButtonText?.desktopCTA}
        isBackButtonDisabled={isSubmitting || isSubmitted}
        isForwardButtonDisabled={isSubmitting || isSubmitted}
        onBackButtonClick={goBack}
        isForwardButtonLoading={isSubmitting || isSubmitted}
      />
      <Modal
        ariaLabel="About Poop Modal"
        shown={shown}
        onCloseModal={() => setShown(false)}
      >
        <ModalContainer>
          <ModalHeading>{modal.heading}</ModalHeading>
          {modal.options.map((option, i) => (
            <ModalContent key={i}>
              <ModalContentTitle>
                {option.title.toUpperCase()}
              </ModalContentTitle>
              <ModalContentBody>{option.text}</ModalContentBody>
            </ModalContent>
          ))}
        </ModalContainer>
      </Modal>
    </StyledForm>
  );
};

PoopForm.displayName = 'PoopForm';

PoopForm.propTypes = {
  poopQuestionPrompt: PropTypes.string.isRequired,
  subheadline: PropTypes.string,
  ctaText: PropTypes.string.isRequired,
  defaultValues: PropTypes.shape({ stoolType: PropTypes.string }).isRequired,
  goBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  modal: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      }),
    ),
  }).isRequired,
  responses: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  ctaButtonText: PropTypes.object,
};
